import { GenericQuery, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'
import { paths } from './workflowsGeneratedTypes'

interface Params {
  authorization: string
}

export class WorkflowsHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.WORKFLOWS,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}
export type WorkflowsResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type WorkflowsQuery<T extends keyof paths, T2 extends keyof paths[T]> = GenericQuery<paths, T, T2>
